// extracted by mini-css-extract-plugin
export default {"label":"File_label__gzadS","uploadPhoto":"File_uploadPhoto__k2GIz"};